if (!customElements.get('sell-shirt-form')) {
  // R2 uploads: Shopify receives text and photo URLs only.
  const FIELD_IDS = {
    name: 'first_name',
    email: 'email',
    expected_price: 'custom#din_forventede_pris_kr',
    comment: 'custom#kommentar_klub_sson_strrelse_og_stand'
  };
  const COPY = {
    de: {
      "loading": "Formular wird verbunden …",
      "unavailable": "Das Formular konnte keine Verbindung herstellen. Deine Angaben sind weiterhin vorhanden. Bitte versuche es erneut.",
      "sending": "Deine Angaben und Fotos werden gesendet …",
      "sent": "Danke. Wir haben deine Anfrage erhalten und melden uns bei dir.",
      "failed": "Die Anfrage konnte nicht gesendet werden. Prüfe deine Angaben und versuche es erneut.",
      "uncertain": "Die Bestätigung steht noch aus. Lass diese Seite offen und sende nicht erneut.",
      "required": "Bitte fülle dieses Feld aus.",
      "price": "Gib einen Preis ab null ein. Verwende nur Zahlen.",
      "tooMany": "Wähle höchstens {max} Fotos aus. Es wurden keine Fotos gesendet.",
      "tooLarge": "Jedes Foto darf höchstens 20 MB groß sein.",
      "fileType": "Verwende JPG, PNG, WebP, HEIC oder GIF.",
      "duplicate": "Wähle unterschiedliche Fotos aus.",
      "uploadHelp": "Wähle 4–{max} Fotos mit jeweils höchstens 20 MB. Beginne mit Vorderseite, Rückseite, Nackenetikett und Pflegeetikett.",
      "sendingButton": "WIRD GESENDET …",
      "sentButton": "GESENDET"
},
    sv: {
      loading: 'Ansluter formuläret…',
      unavailable: 'Formuläret kunde inte ansluta. Dina uppgifter finns kvar. Anslut formuläret igen nedan.',
      sending: 'Skickar dina uppgifter och bilder… Slutför säkerhetskontrollen om den visas.',
      sent: 'Tack. Vi har tagit emot din tröja för värdering och kontaktar dig på den e-postadress du angav.',
      failed: 'Det gick inte att skicka formuläret. Kontrollera uppgifterna nedan och försök igen.',
      uncertain: 'Vi väntar fortfarande på en bekräftelse. Låt sidan vara öppen och skicka inte igen ännu.',
      required: 'Fyll i detta fält.',
      price: 'Ange ett pris på noll eller mer med enbart siffror.',
      tooMany: 'Välj högst {max} bilder. Inga bilder har skickats.',
      tooLarge: 'Varje bild får vara högst 20 MB.',
      fileType: 'Använd bilder i JPG, PNG, WebP, HEIC eller GIF.',
      duplicate: 'Välj olika bilder av tröjan.',
      uploadHelp: 'Välj 4–{max} bilder på högst 20 MB vardera. Välj först framsidan, baksidan, nacketiketten och tvättetiketten; lägg sedan till eventuella detaljbilder.',
      sendingButton: 'SKICKAR…',
      sentButton: 'SKICKAT'
    },
    en: {
      loading: 'Connecting the form…',
      unavailable: 'The form could not connect. Your details are still here. Please reconnect the form below.',
      sending: 'Sending your details and photos… Please complete the security check if it appears.',
      sent: 'Thank you. We have received your shirt for valuation and will contact you at the email address you provided.',
      failed: 'Your submission could not be completed. Please review the details below and try again.',
      uncertain: 'We are still waiting for confirmation. Please keep this page open and do not submit again yet.',
      required: 'Please complete this field.',
      price: 'Enter a price of zero or more, using numbers only.',
      tooMany: 'Choose no more than {max} photos. No photos have been sent.',
      tooLarge: 'Each photo must be 20 MB or smaller.',
      fileType: 'Use JPG, PNG, WebP, HEIC or GIF photos.',
      duplicate: 'Choose different photos for the shirt views.',
      uploadHelp: 'Choose 4–{max} photos, up to 20 MB each. Select the front, back, neck label and care label first; add any detail photos after these.',
      sendingButton: 'SENDING…',
      sentButton: 'SENT'
    },
    da: {
      loading: 'Formularen indlæses…',
      unavailable: 'Formularen kunne ikke oprette forbindelse. Dine oplysninger er stadig her. Tilslut formularen igen nedenfor.',
      sending: 'Dine oplysninger og billeder sendes… Gennemfør sikkerhedstjekket, hvis det vises.',
      sent: 'Tak. Vi har modtaget din trøje til vurdering og kontakter dig på den angivne email-adresse.',
      failed: 'Din henvendelse kunne ikke sendes. Kontrollér oplysningerne nedenfor, og prøv igen.',
      uncertain: 'Vi venter stadig på en bekræftelse. Hold siden åben, og undlad at sende igen endnu.',
      required: 'Udfyld venligst dette felt.',
      price: 'Indtast en pris på nul eller derover, kun med tal.',
      tooMany: 'Vælg højst {max} billeder. Ingen billeder er blevet sendt.',
      tooLarge: 'Hvert billede må højst være 20 MB.',
      fileType: 'Brug billeder i JPG, PNG, WebP, HEIC eller GIF.',
      duplicate: 'Vælg forskellige billeder af trøjen.',
      uploadHelp: 'Vælg 4–{max} billeder på højst 20 MB hver. Vælg først forside, bagside, nakkemærke og vaskemærke; tilføj derefter eventuelle detaljebilleder.',
      sendingButton: 'SENDER…',
      sentButton: 'SENDT'
    }
  };

  customElements.define('sell-shirt-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-custom-form]');
      if (!this.dataset.shopifyFormId || !this.dataset.uploadEndpoint) return;
      this.backend = this.querySelector('[data-native-form]');
      if (!this.form || !this.backend || this.listeners) return;

      this.copy = COPY[this.dataset.language] || COPY.da;
      this.photoInput = this.querySelector('[data-photo-input]');
      this.fileStatus = this.querySelector('[data-file-status]');
      this.fileError = this.querySelector('[data-file-error]');
      this.status = this.querySelector('[data-submission-status]');
      this.error = this.querySelector('[data-submission-error]');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.submitLabel = this.querySelector('[data-submit-label]');
      this.originalLabel = this.submitLabel.textContent;
      this.fallback = this.querySelector('[data-native-fallback]');
      this.clearPhotos = this.querySelector('[data-clear-photos]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.form.addEventListener('submit', (event) => this.submit(event), options);
      this.form.addEventListener('input', () => this.onInput(), options);
      this.photoInput.addEventListener('change', () => this.onInput(), options);
      this.clearPhotos.addEventListener('click', () => {
        this.photoInput.value = '';
        this.onInput();
      }, options);
      this.fallback.addEventListener('click', () => this.showNativeForm(), options);
      this.startedAt = Date.now();
      this.findNativeForm();
    }


    disconnectedCallback() {
      this.uploadController?.abort();
      this.listeners?.abort();
      this.listeners = null;
      this.observer?.disconnect();
      clearTimeout(this.loadTimer);
      clearTimeout(this.submitTimer);
      cancelAnimationFrame(this.frame);
    }

    nativeFields(root) {
      return Object.fromEntries(Object.entries(FIELD_IDS).map(([name, id]) => [
        name, root.getElementById(id) || root.querySelector(`[name="${id}"]`)
      ]));
    }

    findNativeForm() {
      if (!this.isConnected || this.nativeMode) return;
      const container = this.backend.querySelector(`[data-forms-id="forms-root-${this.dataset.shopifyFormId}"]`);
      const host = container?.querySelector('shopify-forms-embed');
      const root = host?.shadowRoot;
      const form = root?.querySelector('form[data-testid="form"]');
      if (form) {
        const fields = this.nativeFields(root);
        const files = [...form.querySelectorAll('input[type="file"]')];
        const known = new Set([...Object.values(fields), ...files]);
        const unknown = [...form.querySelectorAll('input:not([type="hidden"]), textarea, select')]
          .some((input) => !known.has(input));
        // A changed schema or added consent must never be silently bypassed.
        const panel = form.closest('[role="dialog"]')?.parentElement;
        const valid = Object.values(fields).every(Boolean) && !unknown && panel?.parentElement?.id === 'form-container-ref' &&
          files.length === 0 &&
          typeof form.requestSubmit === 'function';
        if (!valid) {
          this.host = host;
          this.nativeRoot = root;
          this.failConnection();
          return;
        }
        this.host = host;
        this.nativeRoot = root;
        this.nativeForm = form;
        this.nativePanel = panel;
        this.fields = fields;
        this.nativeFiles = files;
        this.maxPhotos = 8;
        this.hideNativePanel();
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.readNativeState());
        });
        this.observer.observe(root, { childList: true, subtree: true, attributes: true, characterData: true });
        this.ready = true;
        this.dataset.bridgeState = 'ready';
        this.status.hidden = true;
        this.error.hidden = true;
        this.fallback.hidden = true;
        this.submitButton.disabled = false;
        this.backend.dataset.backendState = 'ready';
        this.querySelector('[data-upload-help]').textContent = this.copy.uploadHelp.replace('{max}', this.maxPhotos);
        this.onInput();
        return;
      }
      if (Date.now() - this.startedAt > 20000) {
        this.failConnection();
        return;
      }
      this.loadTimer = setTimeout(() => this.findNativeForm(), 250);
    }

    hideNativePanel() {
      // Clip the visual panel including its layout wrapper, so the hidden form
      // cannot reserve vertical space. Its sibling captcha stays accessible.
      this.bridgeStyle = document.createElement('style');
      this.bridgeStyle.textContent = `
        [data-sell-shirt-native-panel],
        [data-form-root] > [role="status"],
        [data-testid="app-router"] > :not(#form-container-ref) {
          position: absolute !important;
          width: 1px !important; height: 1px !important;
          min-width: 0 !important; min-height: 0 !important;
          margin: 0 !important; padding: 0 !important;
          overflow: hidden !important; clip-path: inset(50%) !important;
          pointer-events: none !important;
        }
      `;
      this.nativeRoot.append(this.bridgeStyle);
      this.nativePanel.setAttribute('data-sell-shirt-native-panel', '');
      this.nativePanel.setAttribute('aria-hidden', 'true');
      this.nativePanel.inert = true;
    }

    onInput() {
      if (this.pending || this.completed || this.nativeMode) return;
      this.error.hidden = true;
      for (const name of Object.keys(FIELD_IDS)) {
        const field = this.form.elements.namedItem(name);
        field.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      }
      this.validatePhotos(false);
      if (this.ready) {
        try { this.mirror(); } catch { this.failConnection(); }
      }
    }

    validatePhotos(showEmptyError) {
      const files = [...this.photoInput.files];
      const limit = this.maxPhotos || 8;
      let error = '';
      if (files.length < 4) error = this.form.dataset.photoError;
      else if (files.length > limit) error = this.copy.tooMany.replace('{max}', limit);
      else if (files.some((file) => file.size > 20 * 1024 * 1024)) error = this.copy.tooLarge;
      else if (files.some((file) => !/\.(jpe?g|png|webp|heic|heif|gif)$/i.test(file.name))) error = this.copy.fileType;
      else if (new Set(files.map((file) => `${file.name}:${file.size}:${file.lastModified}`)).size !== files.length) error = this.copy.duplicate;
      this.photoInput.setCustomValidity(error);
      this.fileError.textContent = error;
      this.fileError.hidden = !error || (!showEmptyError && files.length === 0);
      this.clearPhotos.hidden = files.length === 0;
      this.fileStatus.textContent = files.length
        ? `${files.length} ${files.length === 1 ? this.form.dataset.photoSingular : this.form.dataset.photoPlural}`
        : this.form.dataset.photoEmpty;
      return !error;
    }

    mirror() {
      if (!this.nativeForm?.isConnected) throw new Error('Native form disconnected');
      for (const [name, target] of Object.entries(this.fields)) {
        let value = this.form.elements.namedItem(name).value.trim();
        if (name === 'expected_price') value = value.replace(',', '.');
        if (name === 'comment' && value) {
          const source = this.dataset.language === 'de'
            ? 'Retrofootballstore.de | EUR'
            : this.dataset.language === 'sv'
            ? 'Retrofootballstore.se | SEK'
            : this.dataset.language === 'en' ? 'Retrofootballstore.co.uk | GBP' : 'Retrotrøjer.dk | DKK';
          value += `\n\n[${source}]\n[SAYU_R2_PHOTOS]\n${(this.photoUrls || []).join('\n')}\n[/SAYU_R2_PHOTOS]`;
        }
        if (target.value === value) continue;
        const prototype = target.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        Object.getOwnPropertyDescriptor(prototype, 'value').set.call(target, value);
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    async submit(event) {
      event.preventDefault();
      if (this.pending || this.completed) return;
      if (!this.ready) { this.failConnection(); return; }
      this.error.hidden = true;
      this.validatePhotos(true);
      for (const name of Object.keys(FIELD_IDS)) {
        const field = this.form.elements.namedItem(name);
        let error = !field.value.trim() ? this.copy.required : '';
        if (name === 'expected_price' && !/^\d+(?:[.,]\d{1,2})?$/.test(field.value.trim())) error = this.copy.price;
        field.setCustomValidity(error);
      }
      if (!this.form.reportValidity()) return;
      try {
        this.setBusy(true);
        this.setStatus(this.copy.sending);
        await this.uploadPhotos();
        if (!this.isConnected) return;
        this.mirror();
        // Let Shopify's own input handlers commit the mirrored values first.
        await new Promise(requestAnimationFrame);
        if (!this.isConnected) return;
        this.awaitingOutcome = true;
        this.nativeForm.requestSubmit();
        this.submitTimer = setTimeout(() => {
          if (this.pending) this.setStatus(this.copy.uncertain);
          // Keep the lock: an unknown outcome is not permission to submit twice.
        }, 120000);
      } catch (error) {
        this.setBusy(false);
        this.showError(error.message || this.copy.failed);
      }
    }

    async uploadPhotos() {
      const files = [...this.photoInput.files];
      const fingerprint = files.map(file => `${file.name}:${file.size}:${file.lastModified}`).join('|');
      if (this.photoFingerprint !== fingerprint) {
        this.photoUrls = [];
        this.uploadSession = null;
        this.photoFingerprint = fingerprint;
      }
      const endpoint = new URL(this.dataset.uploadEndpoint);
      if (endpoint.protocol !== 'https:' && endpoint.hostname !== 'localhost' && endpoint.hostname !== '127.0.0.1') throw new Error('Invalid upload endpoint.');
      this.uploadController = new AbortController();
      const post = async (path, body, headers) => {
        const timeout = setTimeout(() => this.uploadController.abort(), 90000);
        try {
          const response = await fetch(new URL(path, endpoint), { method: 'POST', body, headers, signal: this.uploadController.signal, credentials: 'omit' });
          const data = await response.json();
          if (!response.ok) {
            if (response.status === 401) { this.uploadSession = null; this.photoUrls = []; }
            throw new Error(data.error || this.copy.failed);
          }
          return data;
        } finally { clearTimeout(timeout); }
      };
      if (!this.uploadSession) {
        const data = await post('/sessions', JSON.stringify({ sizes: files.map(file => file.size) }), { 'Content-Type': 'application/json' });
        this.uploadSession = data.session;
      }
      for (let index = 0; index < files.length; index++) {
        if (this.photoUrls[index]) continue;
        this.setStatus(this.dataset.language === 'de'
          ? `Foto ${index + 1} von ${files.length} wird hochgeladen …`
          : this.dataset.language === 'sv'
          ? `Laddar upp bild ${index + 1} av ${files.length}…`
          : this.dataset.language === 'en' ? `Uploading photo ${index + 1} of ${files.length}…` : `Uploader billede ${index + 1} af ${files.length}…`);
        const data = await post('/photos', files[index], { 'Content-Type': 'application/octet-stream', 'X-Upload-Session': this.uploadSession, 'X-Photo-Index': String(index) });
        const url = new URL(data.url);
        if (url.origin !== 'https://storage.sayu.studio' || !url.pathname.startsWith('/retrotrojer/sell-shirt/live/')) throw new Error('Unexpected photo storage location.');
        this.photoUrls[index] = url.href;
      }
      this.setStatus(this.copy.sending);
    }

    readNativeState() {
      if (!this.awaitingOutcome || this.nativeMode || this.completed) return;
      const step = this.nativeRoot.querySelector('[data-current-step]')?.dataset.currentStep;
      if (step === 'success') {
        clearTimeout(this.submitTimer);
        this.completed = true;
        this.dataset.bridgeState = 'success';
        this.pending = false;
        this.form.removeAttribute('aria-busy');
        this.status.dataset.success = 'true';
        this.setStatus(this.copy.sent);
        this.status.focus({ preventScroll: true });
        this.submitLabel.textContent = this.copy.sentButton;
        return;
      }
      if (step === 'error') {
        this.setBusy(false);
        this.failConnection();
        this.showError(this.copy.failed);
        return;
      }
      const button = this.nativeForm.querySelector('[type="submit"]');
      const busy = button?.disabled || button?.getAttribute('aria-disabled') === 'true';
      if (busy) { this.sawNativeBusy = true; return; }
      const errors = [...this.nativeForm.querySelectorAll('output[role="alert"]')]
        .map((node) => node.textContent.trim()).filter(Boolean);
      if (errors.length || this.sawNativeBusy) {
        this.setBusy(false);
        for (const [name, target] of Object.entries(this.fields)) {
          if (target.getAttribute('aria-invalid') === 'true') this.form.elements.namedItem(name).setAttribute('aria-invalid', 'true');
        }
        this.showError([this.copy.failed, ...new Set(errors)].join(' '));
      }
    }

    setBusy(busy) {
      this.pending = busy;
      this.form.setAttribute('aria-busy', String(busy));
      for (const input of this.form.querySelectorAll('input, textarea, button')) input.disabled = busy;
      this.submitLabel.textContent = busy ? this.copy.sendingButton : this.originalLabel;
      this.sawNativeBusy = false;
      if (!busy) {
        this.awaitingOutcome = false;
        this.status.hidden = true;
        clearTimeout(this.submitTimer);
      }
    }

    setStatus(text) {
      this.status.textContent = text;
      this.status.hidden = false;
    }

    showError(text) {
      this.error.textContent = text;
      this.error.hidden = false;
      this.error.focus({ preventScroll: true });
    }

    failConnection() {
      this.ready = false;
      this.dataset.bridgeState = 'unavailable';
      this.submitButton.disabled = true;
      this.status.hidden = true;
      this.error.textContent = this.copy.unavailable;
      this.error.hidden = false;
      this.fallback.hidden = false;
    }

    showNativeForm() {
      if (this.pending) return;
      this.startedAt = Date.now();
      this.setStatus(this.copy.loading);
      this.findNativeForm();
    }

  });
}
